/**
 * Reactive hook for call presence — shows who's in the call
 * before the current user joins (Convex-backed, not Agora SDK).
 */

import { useQuery } from 'convex/react'
import { useMemo } from 'react'
import { api } from '@ppwr/convex/_generated/api'
import type { Id } from '@ppwr/convex/_generated/dataModel'

export function useCallPresence(gameId: Id<'games'> | undefined) {
  const participants = useQuery(
    api.av.presence.getParticipants,
    gameId ? { gameId } : 'skip'
  )

  return useMemo(() => {
    const list = participants ?? []
    return {
      participants: list,
      count: list.length,
      userIds: list.map((p) => p.userId)
    }
  }, [participants])
}
